/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateMenuOrderItemsResultError
 */
export interface ValidateMenuOrderItemsResultError {
    /**
     * 
     * @type {string}
     * @memberof ValidateMenuOrderItemsResultError
     */
    errorMessage: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateMenuOrderItemsResultError
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateMenuOrderItemsResultError
     */
    menuItemId?: string;
}

/**
 * Check if a given object implements the ValidateMenuOrderItemsResultError interface.
 */
export function instanceOfValidateMenuOrderItemsResultError(value: object): value is ValidateMenuOrderItemsResultError {
    if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
    return true;
}

export function ValidateMenuOrderItemsResultErrorFromJSON(json: any): ValidateMenuOrderItemsResultError {
    return ValidateMenuOrderItemsResultErrorFromJSONTyped(json, false);
}

export function ValidateMenuOrderItemsResultErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateMenuOrderItemsResultError {
    if (json == null) {
        return json;
    }
    return {
        
        'errorMessage': json['errorMessage'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'menuItemId': json['menuItemId'] == null ? undefined : json['menuItemId'],
    };
}

export function ValidateMenuOrderItemsResultErrorToJSON(json: any): ValidateMenuOrderItemsResultError {
    return ValidateMenuOrderItemsResultErrorToJSONTyped(json, false);
}

export function ValidateMenuOrderItemsResultErrorToJSONTyped(value?: ValidateMenuOrderItemsResultError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'errorMessage': value['errorMessage'],
        'externalId': value['externalId'],
        'menuItemId': value['menuItemId'],
    };
}

